<h2>{{ 'employeeModule.invoice' | translate }}</h2>
<form [formGroup]="form" #formRef="ngForm" *ngIf="(contracts$ | async)?.length">
  <div class="mb-4">
    <label
      id="contractIdAriaLabel"
      *ngIf="(contracts$ | async)?.length > 1"
      class="form-label"
    >
      {{ 'employeeModule.selectYourContract' | translate }}
    </label>

    <custom-select
      [ariaLabelledby]="'contractIdAriaLabel'"
      [selectableItems]="
        contracts$
          | async
          | mapToSelectableItemsPipe: 'id' : 'description' : 'simple'
      "
      formControlName="contractId"
      [clearable]="false"
      [valueBinder]="'id'"
      [emptyInitValue]="true"
      [allowSelectNullValue]="false"
      [placeholder]="['']"
    ></custom-select>
  </div>
</form>

<div
  *ngIf="isLoading$ | async"
  class="spinner-border mx-auto d-block"
  role="status"
  attr.aria-label="{{ 'wcag.loading' | translate }}"
>
</div>

<div
  class="text-center mt-5"
  [hidden]="(isLoading$ | async) || (contracts$ | async)?.length"
>
  {{ 'employeeModule.noContractsWithDebtorPerson' | translate }}
</div>

<div class="text-center mt-5" [hidden]="!showError || (isLoading$ | async)">
  {{ 'employeeModule.noBookingsToBeInvoiced' | translate }}
</div>
<div
  [hidden]="!(contractEmployeeBookingsToBeInvoiced$ | async)?.length"
  class="my-5"
>
  <invoice-table
    [contract]="selectedContract$ | async"
    [contractEmployeeBookingsToBeInvoiced]="
      contractEmployeeBookingsToBeInvoiced$ | async
    "
  ></invoice-table>

  <form
    [formGroup]="formInvoiceDetails"
    #formRef="ngForm"
    class="mt-5"
    *ngIf="showSendInvoiceButton"
  >
    <div class="row mb-3 align-items-center">
      <div class="col-12 col-md-6 col-lg-8 text-md-end"
        ><label class="col-form-label" id="invoiceLabel">
          <span class="text-danger"> * </span>
          {{ 'employeeModule.invoiceNumber' | translate }}
          <small
            >({{ 'general.required' | translate | lowercase }})</small
          ></label
        >
      </div>

      <div class="col">
        <input
          aria-labelledby="invoiceLabel"
          formControlName="invoiceNumber"
          class="form-control w-100"
          required
        />
      </div>
    </div>
    <div class="row mb-3 align-items-center">
      <div class="col-12 col-md-6 col-lg-8 text-md-end"
        ><label class="col-form-label" id="expirationDateLabel">
          <span class="text-danger">*</span>
          {{ 'employeeModule.expirationDate' | translate }}
          <small
            >({{ 'general.required' | translate | lowercase }})</small
          ></label
        >
      </div>

      <div class="col">
        <native-date-picker
          formControlName="expirationDate"
          [hideLabel]="true"
          [min]="getTodayDateForInput()"
          [ariaDescribedby]="'expirationDateError'"
          ariaLabelledby="expirationDateLabel"
          [isInvalid]="
            (formInvoiceDetails.controls.expirationDate.dirty &&
              formInvoiceDetails.controls.expirationDate.invalid) ||
            isExpirationDateInvalid()
          "
          [required]="true"
        ></native-date-picker>
      </div>
    </div>

    <div
      class="row mb-3 align-items-center"
      *ngIf="(attachDocumentToInvoiceConfig$ | async)?.isVisible"
    >
      <div
        class="col-12 col-md-6 col-lg-8 text-md-end col-form-label"
        [ngClass]="{ 'text-danger': !isUploadedFilesValid }"
      >
        <span
          class="text-danger"
          *ngIf="(attachDocumentToInvoiceConfig$ | async)?.isRequired"
          >*</span
        >
        {{ 'employeeModule.attachDocument' | translate }}
        <!-- <small *ngIf="(attachDocumentToInvoiceConfig$ | async)?.isRequired">
          ({{ 'general.required' | translate | lowercase }})
        </small> -->
      </div>

      <div class="col">
        <upload-document
          (onSubmitFile)="onSubmitDocument($event)"
          [overwrite]="false"
          [skipUploadButton]="true"
          [hidden]="uploadedFiles?.length > 0"
        ></upload-document>

        <table
          *ngIf="uploadedFiles?.length > 0"
          class="table table-striped table-sm"
        >
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col" id="h-name">{{ 'general.name' | translate }}</th>

              <th scope="col" id="h-action"
                ><span class="visibility-hidden"
                  >{{ 'general.actions' | translate} }</span
                ></th
              >
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of uploadedFiles; let i = index">
              <th scope="row" class="align-middle" id="h-counter">{{
                i + 1
              }}</th>
              <td class="align-middle" headers="h-counter h-name">{{
                file.name
              }}</td>
              <td class="align-middle text-end" headers="h-counter h-action">
                <button
                  type="button"
                  class="btn btn-sm btn-soft-secondary"
                  (click)="removeUploadedFile(file)"
                >
                  <i
                    class="far fa-trash-alt"
                    role="img"
                    attr.aria-label="{{ 'wcag.removeFile | translate}}"
                  ></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>

  <div class="text-end">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="isLoading$ | async"
      (click)="onClickDownloadInvoiceSummary()"
    >
      <span
        *ngIf="isLoading$ | async"
        class="spinner-border mx-auto d-block"
        role="status"
        attr.aria-label="{{ 'wcag.loading' | translate }}"
      >
      </span>
      <span *ngIf="!(isLoading$ | async)">
        {{ 'employeeModule.downloadInvoice' | translate }}
      </span>
    </button>
  </div>

  <div class="mb-3">
    <p class="text-center mb-3" *ngIf="showSendInvoiceButton">
      {{
        'employeeModule.invoicePdfExplanation'
          | translate
          | replaceVarInString: '$DEBTOR$' : debtorText
      }}
    </p>

    <button
      *ngIf="showSendInvoiceButton"
      [disabled]="
        sendingInProgress ||
        !formInvoiceDetails.valid ||
        ((attachDocumentToInvoiceConfig$ | async)?.isRequired &&
          (!uploadedFiles || uploadedFiles?.length == 0))
      "
      type="button"
      class="btn btn-primary d-block w-100"
      (click)="onClickSendInvoice()"
    >
      {{ 'employeeModule.sendInvoice' | translate }}
    </button>
  </div>
</div>

<div class="mt-5" [hidden]="(isLoading$ | async) || !documents?.length">
  <h3>{{ 'employeeModule.documents' | translate }}</h3>
  <table class="table table-sm table-hover">
    <tbody>
      <tr *ngFor="let document of documents">
        <td>
          {{
            document.fileName
              ? document.fileName
              : ('employeeModule.invoice' | translate)
          }}
        </td>
        <td class="text-end">
          <a
            class="btn btn-soft-primary"
            [href]="document.publicUrl"
            target="_blank"
          >
            {{ 'general.download' | translate }}
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
